import React from "react";

const AppliedCalendarFilled = ({ cls }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <rect
        x="5.00488"
        y="2.65332"
        width="1.53544"
        height="2.59533"
        rx="0.767718"
        fill="currentColor"
      />
      <rect
        x="0.69043"
        y="8.93945"
        width="18.8238"
        height="1.58704"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1576 9.68159C18.51 9.98113 17.7932 10.1476 17.039 10.1476C14.1519 10.1476 11.8115 7.7085 11.8115 4.69977C11.8115 4.53734 11.8183 4.37658 11.8317 4.21777H3.69043C2.03358 4.21777 0.69043 5.56092 0.69043 7.21777V18.77C0.69043 20.4269 2.03358 21.77 3.69043 21.77H16.1576C17.8145 21.77 19.1576 20.4269 19.1576 18.77V9.68159Z"
        fill="currentColor"
      />
      <rect
        x="0.69043"
        y="8.94434"
        width="18.4668"
        height="1.59712"
        fill="white"
      />
      <ellipse
        cx="17.0078"
        cy="4.71358"
        rx="4.30274"
        ry="4.48409"
        fill="currentColor"
      />
      <path
        d="M15.6855 4.86346L16.3076 5.51169C16.3854 5.59277 16.5147 5.59386 16.5938 5.51412L18.3276 3.76758"
        stroke="white"
        strokeLinecap="round"
      />
      <ellipse
        cx="6.66738"
        cy="14.0716"
        rx="0.738671"
        ry="0.769804"
        fill="white"
      />
      <ellipse
        cx="9.62148"
        cy="14.0716"
        rx="0.738671"
        ry="0.769804"
        fill="white"
      />
      <ellipse
        cx="12.5766"
        cy="14.0716"
        rx="0.738671"
        ry="0.769804"
        fill="white"
      />
    </svg>
  );
};

export default AppliedCalendarFilled;
